import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, ViewController, Modal, AlertController, ToastController } from 'ionic-angular';

import { ClientCreatePage } from '../client-create/client-create';

import { Items } from '../../providers/providers';
import { Client } from '../../models/client';
import { Assessment } from '../../models/assessment';
import { UserAccount } from '../../models/account';
import { UserData } from '../../models/user';

/**
 * Generated class for the ClientPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-client',
  templateUrl: 'client.html',
})

export class ClientPage {
  currentItems: Client[];
  responseData: any;
  administer: string;
  assessment: Assessment;
  userAccountData: UserAccount;
  userData: UserData;
  showAddClientButton: boolean;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public modalCtrl: ModalController, public items: Items, public viewCtrl: ViewController, public toastCtrl: ToastController, public alertCtrl: AlertController) {
    this.items.getClientList().subscribe(res => {
      if (res) {
        this.currentItems = res;
      }
    }, err => {
      console.error('ERROR', err);
    });
    this.userData = <UserData>JSON.parse(localStorage.getItem('userData'));
    if(this.userData.usertype_id === "1" || this.userData.usertype_id === "2"){
      this.showAddClientButton = true
    }
  }

  //ionViewDidLoad() {
  ionViewDidEnter() {
    //this.currentItems = this.items.getClients(); 
    this.administer = this.navParams.get('administer');
    this.assessment = this.navParams.get('assessment');
  }


  /**
   * Prompt the user to add a new item. This shows our ItemCreatePage in a
   * modal and then adds the new item to our data source if the user created one.
   */
  addClient() {
    this.items.getAccountDetails().subscribe(res => {
      if (res) {
        this.userAccountData = res;
        if (parseInt(this.userAccountData.max_clients) - this.userAccountData.client_count < 4 ||
          this.userAccountData.client_count > parseInt(this.userAccountData.max_clients)) {
          this.presentAlert();
        } else {
          let addModal = this.modalCtrl.create(ClientCreatePage, { userData: this.userAccountData }, { cssClass: "add-client-modal" });
          addModal.onDidDismiss(item => {
            if (item.dismiss === 'done') {
              let client = this.items.addClient(item.form);//this should return back the client
              client.map(res => res.json().data.client)
                .subscribe(res => {
                  // If the API returned a successful response, push the response in the clientsList
                  this.clientSelected(res);
                }, err => {
                  console.error('ERROR', err);
                });
              //if client is returned try to invoke the clientSelected()
              this.currentItems = this.items.getClients();
            }
          })
          addModal.present();
        }
      }
    }, err => {
      console.error('ERROR', err);
    });


  }

  cancel() {
    this.viewCtrl.dismiss();
  }

  clientSelected(item) {
    let client = { clientId: item.id, clientFirstName: item.first_name, clientLastName:item.last_name, clientEmail: item.email, clientEmail2: item.parent_2_email, parentName1: item.parent_1_name, parentName2: item.parent_2_name };
    let addModal: Modal;
    if (this.administer == 'administer') {
      if (this.assessment == undefined) {
        addModal = this.modalCtrl.create('SelectAssessmentPage', { client: client });
        addModal.onDidDismiss(item => {
          this.viewCtrl.dismiss();
        })
      } else {
        addModal = this.modalCtrl.create('SelectAssessmentPage', { client: client, assessment: this.assessment });
        addModal.onDidDismiss(item => {
          this.viewCtrl.dismiss();
        })
      }
    }
    if (this.administer == 'schedule') {
      addModal = this.modalCtrl.create('SchedulePage', { client: client, assessment: this.assessment });
      addModal.onDidDismiss(data => {
        if (data.dismiss == 'create') {
          let toast = this.toastCtrl.create({
            message: 'New scheduler created',
            duration: 3000,
            position: 'top'
          });
          toast.present();
          this.viewCtrl.dismiss();
        }
      })
    }
    if (this.administer == 'email') {
      addModal = this.modalCtrl.create('EmailPage', { client: client, assessment: this.assessment });
      addModal.onDidDismiss(data => {
        if (data.dismiss == 'create') {
          let toast = this.toastCtrl.create({
            message: 'Assessment email sent',
            duration: 3000,
            position: 'top'
          });
          toast.present();
          this.viewCtrl.dismiss();
        }
      })
    }
    // added for new battery feature
    if (this.administer == 'administerBattery') {
        addModal = this.modalCtrl.create('SelectAssessmentPage', { client: client, batteryAssessments: this.assessment }); 
    }

    if (this.administer == 'scheduleBattery') {
      addModal = this.modalCtrl.create('SchedulePage', { client: client, batteryAssessments: this.assessment });
      addModal.onDidDismiss(data => {
        if (data.dismiss == 'create') {
          let toast = this.toastCtrl.create({
            message: 'New scheduler created',
            duration: 3000,
            position: 'top'
          });
          toast.present();
          this.viewCtrl.dismiss();
        }
      })
    }
    if (this.administer == 'emailBattery') {
      addModal = this.modalCtrl.create('EmailPage', { client: client, batteryAssessments: this.assessment });
      addModal.onDidDismiss(data => {
        let toast = this.toastCtrl.create({
          message: 'Assessment email sent',
          duration: 3000,
          position: 'top'
        });
        toast.present();
      })
    }

    addModal.present();
  }

  filterClients(ev) {
    var val = ev.target.value;
    this.currentItems = this.items.getClients(val);
    return this.currentItems;

  }

  calculateAge(birthday) {
    if (birthday) {

      var timeDiff = Math.abs(Date.now() - Date.parse(birthday));
      //Used Math.floor instead of Math.ceil
      //so 26 years and 140 days would be considered as 26, not 27.
      return Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
    }
  }

  presentAlert() {
    let alert = this.alertCtrl.create({
      title: parseInt(this.userAccountData.max_clients) - this.userAccountData.client_count + ' clients left on your limit',
      subTitle: 'You are currently on the ' + this.userAccountData.chargebee_plan + ' Plan, which allows you to have ' + this.userAccountData.max_clients + ' clients. You currently have ' + this.userAccountData.client_count + ' clients.' + ' Would you like to upgrade to increase your limit?',
      buttons: [
        {
          text: 'Later',
          handler: data => {
            // console.log('Cancel clicked');
            if (this.userAccountData.client_count < parseInt(this.userAccountData.max_clients)) {
            let addModal = this.modalCtrl.create(ClientCreatePage, { userData: this.userAccountData }, { cssClass: "add-client-modal" });
            addModal.onDidDismiss(item => {
              if (item.dismiss === 'done') {
                let client = this.items.addClient(item.form);//this should return back the client
                client.map(res => res.json().data.client)
                  .subscribe(res => {
                    // If the API returned a successful response, push the response in the clientsList
                    this.clientSelected(res);
                  }, err => {
                    console.error('ERROR', err);
                  });

                //if client is returned try to invoke the clientSelected()
                this.currentItems = this.items.getClients();
              }
            })
            addModal.present();
            }
          }
        },
        {
          text: 'Upgrade',
          handler: data => {
            this.navCtrl.push('account');
          }
        }
      ]
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/client/client.ts